import 'jquery';
import 'bootstrap-loader';
require('angular');
require('angular-aria');
require('angular-animate');
require('angular-ui-router');
require('angular-ui-bootstrap');
require('angular-chart.js');
require('angular-xeditable');
require('angular-sanitize');
require('number-to-words');
require("angular-hotkeys")
require("./node_modules/angular-auto-validate/dist/jcs-auto-validate.js")
require("./assets/js/alcomponents")
require("./assets/js/alservices")
require("./assets/js/select2.js");
require("./assets/js/select2-comp.js");


//////////////////
// WEBPACK FOOTER
// ./vendor.js
// module id = 228
// module chunks = 0